<template>
  <div>
    <div
      v-if="loading"
      class="text-center">
      <coozzy-spinner />
    </div>
    <div v-if="!loading">
      <div
        v-for="object in objectsWithId"
        :key="object.id">
        <add-vacancy-view
          :id="'add-vacancy-' + object.id"
          :ref="'add-vacancy-' + object.id"
          :object-id="object.id"
          :process-object="object"
          :target="'enterTermination'"
          :details-of-termination="detailsOfTermination.filter(e => e?.objectId === object.id)"
          :enter-termination-execute-save="true"
          @vacancy-loaded="vacancyLoaded"
          @validated-vacancy="validatedVacancy"
          @added-vacancy="addedVacancy"
          @object-marketing-note-updated="objectMarketingNoteUpdated" />
      </div>
    </div>
  </div>
</template>

<script>

import AddVacancyView from '@/addVacancy/AddVacancyView'

export default {
  name: 'EnterTerminationAddTenancy',
  components: {
    AddVacancyView
  },
  props: {
    selectedObjectToProcess: {
      type: Array,
      required: true
    },
    detailsOfTermination: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      addedObjects: [],
      loading: false,
      validateObjects: [],
      loadedObjects: []
    }
  },
  computed: {
    objectsWithId() {
      return this.selectedObjectToProcess.filter(object => object?.id)
    },
    vacanciesReady() {
      return this.objectsWithId.length > 0 &&
        this.objectsWithId.every(object => this.loadedObjects.includes(object.id))
    }
  },
  watch: {
    vacanciesReady: {
      immediate: true,
      handler(ready) {
        this.$emit('vacancies-ready', ready)
      }
    }
  },
  methods: {
    vacancyLoaded(ready, objectId) {
      if (!objectId) {
        return
      }
      if (ready) {
        if (!this.loadedObjects.includes(objectId)) {
          this.loadedObjects = [...this.loadedObjects, objectId]
        }
      } else {
        this.loadedObjects = this.loadedObjects.filter(id => id !== objectId)
      }
    },
    validateBeforeSaveAddVacancy() {
      this.loading = false
      // Always re-validate on each Save click; stale entries after a failed create would skip re-validation.
      this.validateObjects = []
      for (const object of this.objectsWithId) {
        this.$refs['add-vacancy-' + object.id]?.[0]?.validateBeforeSave()
      }
    },
    validatedVacancy(success, value) {
      if (success === false) {
        this.$emit('all-vacancy-added', false)
        this.validateObjects = []
        this.loading = false
      } else {
        // Ignore re-emits from saveClicked → validateBeforeSave (already counted this round).
        if (this.validateObjects.includes(value)) {
          return
        }
        this.validateObjects.push(value)
        if (this.objectsWithId.length === this.validateObjects.length) {
          this.saveAddVacancy()
        }
      }
    },
    saveAddVacancy() {
      for (const object of this.objectsWithId) {
        if (!this.addedObjects.includes(object.id)) {
          this.$refs['add-vacancy-' + object.id]?.[0]?.saveClicked()
        }
      }
    },
    addedVacancy(success, value) {
      if (success === false) {
        this.loading = false
        this.validateObjects = []
        this.$emit('all-vacancy-added', false)
      } else {
        if (this.addedObjects.includes(value)) {
          this.addedObjects = this.addedObjects.filter(item => item !== value)
        } else {
          this.addedObjects.push(value)
        }
        if (this.objectsWithId.length === this.addedObjects.length) {
          this.loading = false
          this.$emit('all-vacancy-added', true)
        }
      }
    },
    objectMarketingNoteUpdated(marketingNote, objectId) {
      this.$emit('object-marketing-note-updated', marketingNote, objectId)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
